"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  undo: {
    toolbar: 'Undo'
  },
  redo: {
    toolbar: 'Redo'
  },
  clear: {
    toolbar: 'Clear'
  },
  h: {
    toolbar: 'Headings'
  },
  h1: {
    toolbar: 'Heading 1',
    placeholder: 'Heading 1'
  },
  h2: {
    toolbar: 'Heading 2',
    placeholder: 'Heading 2'
  },
  h3: {
    toolbar: 'Heading 3',
    placeholder: 'Heading 3'
  },
  h4: {
    toolbar: 'Heading 4',
    placeholder: 'Heading 4'
  },
  h5: {
    toolbar: 'Heading 5',
    placeholder: 'Heading 5'
  },
  h6: {
    toolbar: 'Heading 6',
    placeholder: 'Heading 6'
  },
  bold: {
    toolbar: 'Bold',
    placeholder: 'Bold'
  },
  italic: {
    toolbar: 'Italic',
    placeholder: 'Italic'
  },
  strikethrough: {
    toolbar: 'Strike',
    placeholder: 'Strike'
  },
  quote: {
    toolbar: 'Blockquote',
    placeholder: 'Blockquote'
  },
  ul: {
    toolbar: 'Unordered list',
    placeholder: 'Unordered list'
  },
  ol: {
    toolbar: 'Ordered list',
    placeholder: 'Ordered list'
  },
  table: {
    toolbar: 'Insert table'
  },
  hr: {
    toolbar: 'Line'
  },
  link: {
    toolbar: 'Insert link',
    descPlaceholder: 'Link'
  },
  image: {
    toolbar: 'Insert image'
  },
  imageLink: {
    toolbar: 'Insert link'
  },
  uploadImage: {
    toolbar: 'Upload Image'
  },
  code: {
    toolbar: 'Insert Codeblock'
  },
  save: {
    toolbar: 'Save'
  },
  preview: {
    enabled: 'Preview enabled',
    disabled: 'Preview disabled'
  },
  toc: {
    title: 'Directory navigation',
    enabled: 'Toc enabled',
    disabled: 'Toc disabled'
  },
  syncScroll: {
    enabled: 'Sync scroll enabled',
    disabled: 'Sync scroll disabled'
  },
  fullscreen: {
    enabled: 'Full screen(Press ESC to exit)',
    disabled: 'Exit Full Screen'
  }
};
exports.default = _default;